<template>
  <button type="button" class="nixia-attachment-download" @click="download">
    <span class="nixia-attachment-download-icon" :class="iconWrapperClass">
      <i :class="iconClass"></i>
    </span>
    <span class="nixia-attachment-download-info">
      <span class="nixia-attachment-download-name">{{ displayName }}</span>
      <span class="nixia-attachment-download-hint">{{ typeLabel }} · Clique para baixar</span>
    </span>
    <i class="fa-solid fa-download nixia-attachment-download-action"></i>
  </button>
</template>

<script>
export default {
  name: "NixiaAttachmentDownload",
  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayName() {
      return this.attachment.fileName || this.attachment.title || `arquivo.${this.attachment.type}`;
    },
    typeLabel() {
      return (this.attachment.type || "arquivo").toUpperCase();
    },
    iconClass() {
      if (this.attachment.type === "xlsx") return "fa-solid fa-file-excel";
      if (this.attachment.type === "pdf") return "fa-solid fa-file-pdf";
      if (this.attachment.type === "xml") return "fa-solid fa-file-code";
      return "fa-solid fa-file";
    },
    iconWrapperClass() {
      return `nixia-attachment-download-icon-${this.attachment.type || "default"}`;
    },
  },
  methods: {
    base64ToBuffer(base64) {
      const binary = atob(base64);
      const length = binary.length;
      const buffer = new ArrayBuffer(length);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < length; i += 1) view[i] = binary.charCodeAt(i);
      return buffer;
    },
    isTextContent() {
      return this.attachment.type === "xml";
    },
    fallbackMime() {
      if (this.attachment.type === "xlsx")
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (this.attachment.type === "pdf") return "application/pdf";
      return "application/xml";
    },
    buildBlob() {
      const { content, mediaType } = this.attachment;
      const mime = mediaType || this.fallbackMime();
      if (this.isTextContent()) {
        return new Blob([content], { type: `${mime};charset=utf-8` });
      }
      return new Blob([this.base64ToBuffer(content)], { type: mime });
    },
    download() {
      if (!this.attachment.content) return;
      const blob = this.buildBlob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = this.displayName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
    },
  },
};
</script>

<style scoped>
.nixia-attachment-download {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-base);
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
}

.nixia-attachment-download:hover {
  background: var(--bg-hover);
}

.nixia-attachment-download-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  font-size: 18px;
  flex-shrink: 0;
}

.nixia-attachment-download-icon-xlsx {
  background: var(--bg-elevated);
  color: var(--color-success);
}

.nixia-attachment-download-icon-pdf {
  background: var(--bg-elevated);
  color: var(--color-danger);
}

.nixia-attachment-download-icon-xml {
  background: var(--bg-elevated);
  color: var(--color-info);
}

.nixia-attachment-download-icon-default {
  background: var(--bg-elevated);
  color: var(--text-secondary);
}

.nixia-attachment-download-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.nixia-attachment-download-name {
  color: var(--text-primary);
  font-size: 13.5px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nixia-attachment-download-hint {
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.nixia-attachment-download-action {
  color: var(--text-secondary);
  font-size: 14px;
  flex-shrink: 0;
}
</style>
